// src/Components/Torneo/AgregarTorneoBoton.jsx
import React from 'react';
import '../Styles/AddCard.css'; // Asegúrate de tener los estilos en este archivo
import plusIcon from '../../../assets/plus-icon.jpg'; // Ruta del icono de suma

const AgregarCardBoton = ({ image, onOpenModal }) => {
    return (
        <div className="agregar-torneo-card" onClick={onOpenModal}>
            <div className="image-overlay-container">
                <img src={plusIcon} alt="Agregar" className="plus-icon" />
            </div>
            <div className="card-content">
                <p className="add-text"></p>
                <img src={image}  className="card-image" />
            </div>
        </div>
    );
};

export { AgregarCardBoton };
